import { CPLAnalytics } from "setup/appInsights/CPLAnalytics";
import ClientBudgetHeadersTable from "./components/ClientBudgetHeadersTable";
import PageWrapper from "app/modules/shared/PageWrapper";
import { useParams } from "react-router-dom";

const ClientBudgetHeadersTablePage: React.FC = () => {
  const { clientID } = useParams();

  return (
    <CPLAnalytics pageName="Client Budget Headers">
      <PageWrapper
        data-test-id="budget-headers-page__back-button"
        title="Budget Headers"
        backTo={`/ClientBudgets/${clientID}`}
      >
        <ClientBudgetHeadersTable />
      </PageWrapper>
    </CPLAnalytics>
  );
};

export default ClientBudgetHeadersTablePage;
